<a target="_blank" [href]="href$ | async">
    <span>
        <ng-content></ng-content>
    </span>
</a>
